import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { Loading } from "../../components/Elements/Loading";

const Home = lazy(() => import(`./HomePage`));
const Service = lazy(() => import(`./ServicePage`));
const AboutPage = lazy(() => import(`./AboutPage`));

const HomeViews = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route
          path="/"
          element={<Home title="Home" />}
        />
        <Route
          path="/service"
          element={<Service title="Service" />}
        />
        <Route
          path="/about"
          element={<AboutPage title="About" />}
        />
      </Routes>
    </Suspense>
  );
};

export default HomeViews;
